import React from 'react';
import Info from './Info';
import ChevronDown from './ChevronDown';
import ChevronUp from './ChevronUp';
import ArrowRightAlt from './ArrowRightAlt';
import ArrowBack from './ArrowBack';
import Calendar from './Calendar';
import CarPrivate from './CarPrivate';
import Engine from './Engine';
import Transmission from './Transmission';
import LocationSelect from './LocationSelect';
import ChargingType from './ChargingType';
import Clock from './Clock';
import ParkingGarage from './ParkingGarage';
import Close from './Close';
import Search from './Search';

const icons = {
  'info': <Info />,
  'chevron-down': <ChevronDown />,
  'chevron-up': <ChevronUp />,
  'arrow-back': <ArrowBack />,
  'arrow-right-alt': <ArrowRightAlt />,
  'calendar': <Calendar />,
  'car-private': <CarPrivate />,
  'engine': <Engine />,
  'transmission': <Transmission />,
  'location-select': <LocationSelect />,
  'charging-type': <ChargingType />,
  'clock': <Clock />,
  'close': <Close />,
  'parking-garage': <ParkingGarage />,
  'search': <Search />,
};

const IconList = {...icons};

export default IconList;
